import * as t from 'io-ts';

import {RCardIdRef} from '../../../../../models/api/apiTypes';
import {RPreviewCardMerge} from '../../../../../models/api/previewCardMergeModel';
import {RAsyncStatus} from '../../../../appTypes';
import {
  ContactsManagerSidePanelTypesEnum,
  RContactsManagerSidePanelStateBase,
} from './contactsManagerSidePanelStateBase';

/*
 * Runtime types.
 */

const RContactsManagerMergeContactsStateDirty = t.intersection([
  RContactsManagerSidePanelStateBase,
  t.type({
    type: t.literal(ContactsManagerSidePanelTypesEnum.MERGE_CONTACTS),
    status: RAsyncStatus,
    cardIds: t.readonlyArray(RCardIdRef),
  }),
  t.partial({
    previewCardMerge: RPreviewCardMerge,
  }),
]);

/*
 * Types.
 */

export interface ContactsManagerMergeContactsState
  extends Readonly<t.TypeOf<typeof RContactsManagerMergeContactsStateDirty>> {}
export const RContactsManagerMergeContactsState = t.clean<ContactsManagerMergeContactsState>(
  RContactsManagerMergeContactsStateDirty as any,
);
